{"id":"Tags","prefabs":{"default":{"children":[{"component":"Tags","options":"options:*"}]}}}